import React from "react";
import { FileText, FileImage, FileVideo, File } from "lucide-react";

const FilePreviewModal = ({ file, onClose }) => {
  if (!file) return null;
  const { name, type, downloadUrl, createdAt, updatedAt, modifiedAt } = file;

  // Pick the most precise date
  let dateObj = null;
  if (updatedAt && updatedAt.seconds) dateObj = new Date(updatedAt.seconds * 1000);
  else if (modifiedAt && modifiedAt.seconds) dateObj = new Date(modifiedAt.seconds * 1000);
  else if (createdAt && createdAt.seconds) dateObj = new Date(createdAt.seconds * 1000);
  else if (updatedAt) dateObj = new Date(updatedAt);
  else if (modifiedAt) dateObj = new Date(modifiedAt);
  else if (createdAt) dateObj = new Date(createdAt);

  // Icon based on file type
  let icon = <File size={22} className="text-gray-400" />;
  if (type && type.startsWith("image/")) icon = <FileImage size={22} className="text-blue-400" />;
  else if (type === "application/pdf" || name.endsWith(".pdf")) icon = <File size={22} className="text-red-500" />;
  else if (type && type.startsWith("video/") || name.match(/\.(mp4|mov|avi|mkv)$/i)) icon = <FileVideo size={22} className="text-purple-500" />;
  else if (name.match(/\.(docx?|odt)$/i)) icon = <File size={22} className="text-blue-700" />;
  else if (type === "text/plain" || name.match(/\.(txt|md)$/i)) icon = <FileText size={22} className="text-gray-500" />;

  let content;
  if (type.startsWith("image/")) {
    content = <img src={downloadUrl} alt={name} className="max-w-full max-h-[70vh] mx-auto" />;
  } else if (type === "application/pdf") {
    content = <iframe src={downloadUrl} title={name} className="w-full h-[70vh]" />;
  } else if (type === "text/plain") {
    content = <iframe src={downloadUrl} title={name} className="w-full h-[70vh] bg-gray-50" />;
  } else if (name.endsWith(".docx")) {
    content = <iframe src={`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(downloadUrl)}`} title={name} className="w-full h-[70vh]" />;
  } else {
    content = <div className="text-gray-500 text-center">Preview not available. <a href={downloadUrl} target="_blank" rel="noopener noreferrer" className="text-blue-600 underline">Download</a> to view.</div>;
  }

  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-lg p-4 w-full max-w-2xl relative">
        <button className="absolute top-2 right-2 text-gray-600 hover:text-red-600 text-2xl font-bold" onClick={onClose} aria-label="Close">✕</button>
        <div className="flex items-center gap-3 mb-2">
          {icon}
          <h3 className="text-lg font-bold break-all">{name}</h3>
        </div>
        {dateObj && (
          <div className="text-xs text-gray-500 mb-2">Last modified: {dateObj.toLocaleString()}</div>
        )}
        <div className="overflow-auto">{content}</div>
      </div>
    </div>
  );
};

export default FilePreviewModal;
